import homeApi from './home'

export default {
    ...homeApi,
}